export default __webpack_public_path__ + "static/media/IF_MyStrengths_FullProfile_Desc_10.961af652.jpg";